<script setup>
    import { storeToRefs } from 'pinia';
    import * as http from '@/libs/http';
    import { isEmpty,inArray,isMobile } from '@/libs/utils';
	import modules from '@/components/design/index.js';
    import { useUserStore } from '@/store/modules/user';
    import storage from '@/libs/storage';
    import config from '@/config';
    
    const userStore = useUserStore();
    const user = storeToRefs(userStore);
    
    const props = defineProps({
        module: {
            type: Array,
            default: ["top","search","navigation","footer"]
        },
        style: {
            type: [Object,String],
            default: {}
        },
        isMain: {
            type: Boolean,
            default: true
        },
        isCart: {
            type: Boolean,
            default: true
        }
    })

    let pcGlobal = storage.getJson("pc_global",{});
    const isLoading = ref(false);
	const result = ref(pcGlobal);
	onMounted(()=>{
        isLoading.value = isEmpty(pcGlobal) ? true : false;
        http.get("index/global",{ temp_id: "pc" }).then(res=>{
            isLoading.value = false;
            if(res.code == 1){
                result.value = res.data;
                if(props.isMain){
                    storage.setJson("pc_global",res.data);
                }
            }
        });

        if(isMobile()){
            window.location.href = config.base_url.replace("homeapi","mobile");
        }
        
	});
    
    const isFirstCart = ref(false);
    if(!isFirstCart.value){
        isFirstCart.value = true;
        userStore.getCartCount();
    }

</script>

<template>
    <div class="layout">
        <component v-if="!isEmpty(result) && !isLoading && modules.top && inArray('top',props.module) && props.isMain" :is="modules.top" :data="result.top.value"></component>
        <component v-if="!isEmpty(result) && !isLoading && modules.search && inArray('search',props.module) && props.isMain" :is="modules.search" :data="result.search.value"></component>
        <component v-if="!isEmpty(result) && !isLoading && modules.navigation && inArray('navigation',props.module) && props.isMain" :is="modules.navigation" :data="result.navigation.value"></component>
        <slot v-if="!isLoading"></slot>
        <component v-if="!isEmpty(result) && !isLoading && modules.footer && inArray('footer',props.module) && props.isMain" :is="modules.footer" :data="result.footer.value"></component>
        <div class="service" v-if="props.isCart">
            <div>
                <a-link to="/cart/index">
                    <el-badge :value="user.cartCount.value" class="item" :offset="[-6,12]">
                        <span><img src="@/assets/images/cart.png" /></span>
                        <span>{{ $t("components.layout.cart") }}</span>
                    </el-badge>
                </a-link>
            </div>
            <div>
                <a-link to="/ucenter/index">
                    <span><img src="@/assets/images/ucenter.png" /></span>
                    <span>{{ $t("components.layout.my") }}</span>
                </a-link>
            </div>
            <!-- <div>
                <a-link to="/service/online">
                    <span><img src="@/assets/images/online.png" /></span>
                    <span>客服</span>
                </a-link>
            </div> -->
        </div>
    </div>
</template>

<style lang="scss" scoped>
.layout {
    .service {
        width: 65px;
        height: 155px;
        background-color: #fff;
        border-top-left-radius: 15px;
        border-bottom-left-radius: 15px;
        box-shadow: 0 0 15px 5px rgba(0, 0, 0, .2);
        position: fixed;
        z-index: 500000;
        top: 50%;
        transform: translateY(-50%);
        right: 0;
        display: flex;
        flex-direction: column;
        padding-top: 10px;
        a {
            text-decoration: none;
        }
        div {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-top: 2px;
            cursor: pointer;
            &:hover {
                opacity: 0.8;
            }
            span {
                color: #4f4f4f;
                font-size: 12px;
                display: block;
                text-align: center;
            }
        }
    }
}
</style>